import { useEffect } from 'react';
import { createLeaveGuard } from 'v5/platform/navigation/createLeaveGuard';

/** What openers put in the drawer: a resource, or at least its id. */
export type ResourceDrawerTarget = { id?: number | string } | null | undefined;

/**
 * The resource drawer holds this while it shows a resource; opening another
 * one (`openContactSidebar`) asks it first, so unsaved changes in the drawer
 * are never replaced without the user's consent.
 */
export const resourceDrawerGuard = createLeaveGuard<ResourceDrawerTarget>();

/**
 * Holds `resourceDrawerGuard` for the drawer showing `resourceId`: the same
 * resource opens right away, another one asks through `requestLeave` (the
 * drawer's unsaved-changes protection).
 */
export function useHoldResourceDrawer(
  resourceId: number | string | undefined,
  requestLeave: () => Promise<boolean>
) {
  useEffect(
    () =>
      resourceDrawerGuard.hold(target =>
        target?.id != null && String(target.id) === String(resourceId)
          ? true
          : requestLeave()
      ),
    [resourceId, requestLeave]
  );
}
